import "@/components/dashboard/widgets/job_alerts/widget.scss";
import { SubscriptionCountProvider } from "@components/job_alerts/header.tsx";
import { JobAlertsList } from "@components/dashboard/widgets/job_alerts/list.tsx";
import { Header } from "@components/dashboard/widgets/job_alerts/header.tsx";
import { PausedBanner } from "@components/job_alerts/paused_banner.tsx";
import useSubscriptions from "@/queries/use_subscriptions.ts";
import { useDashboardPreview } from "@components/dashboard/preview_context.tsx";

const JobAlerts = () => {
  const { preview } = useDashboardPreview();
  const { data } = useSubscriptions({ mock: preview });

  return (
    <>
      <SubscriptionCountProvider>
        <Header />
      </SubscriptionCountProvider>
      {data.jobAlertsPaused && <PausedBanner />}
      <JobAlertsList />
    </>
  );
};

export default JobAlerts;
